import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { db } from '@/db';

export default {
  name: 'home-mixin',

  data() {
    return {
      initialData: {},
      appliedTeamsWithNoMatch: [],
      loadingConnectQuestions: false,
    };
  },

  computed: {
    ...mapState(['user_data', 'userMatches', 'bindedUserData']),

    ...mapGetters(['userAppliedTeamsWithoutMatch']),

    getNationality() {
      if (this.$store.state.user_data.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.$store.state.user_data.nationality,
        );
        return found.item_text;
      }
      return 'k.A.';
    },
    formatDate() {
      if (!this.$store.state.user_data.age) return null;

      const [year, month, day] = this.$store.state.user_data.age.split('-');
      return `${day}.${month}.${year}`;
    },
    dateToAge() {
      if (!this.$store.state.user_data.age) return null;
      const [year, month, day] = this.$store.state.user_data.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const today = Date.now();
      const age = moment().diff(dateString, 'years');
      return age;
    },
    sortedHistory() {
      let sorted = [];
      if (this.$store.state.user_data.history) {
        sorted = this.$store.state.user_data.history.sort((a, b) =>
          a.season < b.season ? 1 : b.season < a.season ? -1 : 0,
        );
      }
      return sorted;
    },
    settings() {
      return this.$store.state.user_data.settings;
    },
  },

  watch: {
    galleryImages: (oldImages, newImages) => {
      console.log('CHECK');
      console.log(oldImages, newImages);
    },

    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },

    userAppliedTeamsWithoutMatch(val) {
      console.log('userAppliedTeamsWithoutMatch watcher', { val });
      this.getAppliedTeamWithNoMatches(val);
    },
  },

  methods: {
    async getAppliedTeamWithNoMatches(appliedTeamIds) {
      this.loadingConnectQuestions = true;

      if (appliedTeamIds.length) {
        const teamIds = appliedTeamIds.reverse();
        this.appliedTeamsWithNoMatch = [];

        const getTeams = teamIds.map(async (id) => {
          const team = await db
            .collection('teams')
            .doc(id)
            .get({ source: 'server' })
            .then((snapshot) => snapshot.data());
          return team;
        });

        const teams = await Promise.all(getTeams);
        this.appliedTeamsWithNoMatch = teams.filter((t) => t);
      } else {
        this.appliedTeamsWithNoMatch = [];
      }
      this.loadingConnectQuestions = false;
    },

    closeMenu() {
      if (this.initialData === JSON.stringify(this.user_data)) {
      } else {
        this.saveData();
        this.initialData = JSON.stringify(this.user_data);
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Daten gespeichert',
        });
      }
      this.bottomSheet = 'hidden';
    },
  },
};
